import { fromJS } from 'immutable';
import {
	FETCH_REALESTATE_SUCCESS,
	FETCH_OBJECTDATA_ERROR
} from '../constants/actionTypes';

const initialState_realestate = fromJS([]);

export function realestate(state = initialState_realestate, {type, payload}) {

	if ( type === FETCH_REALESTATE_SUCCESS ) {
		return payload;
	} else if(type === FETCH_OBJECTDATA_ERROR) {
		return state;
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/js/reducers/realestate.js